$(function() {

    // var slider_arrow_left = '<svg id="slider_arrow_left" viewBox="0 0 451.847 451.847" width="100%" height="100%"><path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0 c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744 c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"></path></svg>';
    var slider_arrow_left = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n" +
        "<svg width=\"15px\" height=\"26px\" viewBox=\"0 0 15 26\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n" +
        "    <defs></defs>\n" +
        "    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n" +
        "        <g id=\"03.Offer\" transform=\"translate(-91.000000, -1087.000000)\" fill=\"#C7C0CB\" fill-rule=\"nonzero\">\n" +
        "            <g id=\"галерея\" transform=\"translate(91.000000, 1020.000000)\">\n" +
        "                <g id=\"arrow-point-to-right-(2)-copy-2\" transform=\"translate(7.500000, 80.000000) scale(-1, 1) translate(-7.500000, -80.000000) translate(0.000000, 67.000000)\">\n" +
        "                    <path d=\"M14.4442442,14.2822832 L3.14848837,25.4577389 C2.42994186,26.169 1.26494186,26.169 0.546744186,25.4577389 C-0.171511628,24.7471106 -0.171511628,23.5945398 0.546744186,22.883969 L10.5417442,12.9953982 L0.547034884,3.10717257 C-0.17122093,2.39625664 -0.17122093,1.24380088 0.547034884,0.533172566 C1.2652907,-0.177743363 2.43023256,-0.177743363 3.14877907,0.533172566 L14.4445349,11.7088009 C14.8036628,12.0642876 14.9830233,12.5296991 14.9830233,12.9953407 C14.9830233,13.4612124 14.803314,13.926969 14.4442442,14.2822832 Z\" id=\"Shape\"></path>\n" +
        "                </g>\n" +
        "            </g>\n" +
        "        </g>\n" +
        "    </g>\n" +
        "</svg>";
    // var slider_arrow_right = '<svg id="slider_arrow_right" viewBox="0 0 451.846 451.847" width="100%" height="100%"><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744 L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284 c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path></svg>';
    var slider_arrow_right = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n" +
        "<svg width=\"15px\" height=\"26px\" viewBox=\"0 0 15 26\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n" +
        "    <defs></defs>\n" +
        "    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n" +
        "        <g id=\"03.Offer\" transform=\"translate(-1100.000000, -1087.000000)\" fill=\"#C7C0CB\" fill-rule=\"nonzero\">\n" +
        "            <g id=\"галерея\" transform=\"translate(91.000000, 1020.000000)\">\n" +
        "                <g id=\"arrow-point-to-right-(2)-copy-3\" transform=\"translate(1009.000000, 67.000000)\">\n" +
        "                    <path d=\"M14.4442442,14.2822832 L3.14848837,25.4577389 C2.42994186,26.169 1.26494186,26.169 0.546744186,25.4577389 C-0.171511628,24.7471106 -0.171511628,23.5945398 0.546744186,22.883969 L10.5417442,12.9953982 L0.547034884,3.10717257 C-0.17122093,2.39625664 -0.17122093,1.24380088 0.547034884,0.533172566 C1.2652907,-0.177743363 2.43023256,-0.177743363 3.14877907,0.533172566 L14.4445349,11.7088009 C14.8036628,12.0642876 14.9830233,12.5296991 14.9830233,12.9953407 C14.9830233,13.4612124 14.803314,13.926969 14.4442442,14.2822832 Z\" id=\"Shape\"></path>\n" +
        "                </g>\n" +
        "            </g>\n" +
        "        </g>\n" +
        "    </g>\n" +
        "</svg>";

    var artListSlider = $(".art-list");
    artListSlider.addClass("owl-carousel");

    artListSlider.owlCarousel({
        // margin: 18,
        dots: false,
        nav: true,
        navText: [slider_arrow_left, slider_arrow_right],
        items: 3,
        // autoplay: true,
        autoplayTimeout: 6000,
        loop: true,
        responsive: {
            0: {
                items: 1,
                dots: true,
                nav: false
                // autoWidth: true,
                // slideBy: 2
            },
            992: {
                items: 2
                // autoWidth: true,
                // slideBy: 2
            },
            1201: {
                items: 3
            }

        },
        // onInitialize: function() {
        //
        // },
        // onResize: function() {
        //
        // }
    });

});